
import { Button } from "@/components/ui/button";
import { Loader2, Mail } from "lucide-react";
import { GroupLeaderRequest } from "@/types/admin-requests";

interface SendInvitationActionProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onSendInvitation: (request: GroupLeaderRequest) => Promise<void>;
}

export const SendInvitationAction = ({
  request,
  processingId,
  onSendInvitation,
}: SendInvitationActionProps) => {
  const isProcessing = !!processingId;
  const isCurrentProcessing = processingId === request.id;
  
  console.log('SendInvitationAction for request:', request.id, {
    email_sent: request.email_sent,
    isProcessing,
    isCurrentProcessing
  });

  return (
    <Button
      variant="outline"
      onClick={() => onSendInvitation(request)}
      disabled={isProcessing}
      className="bg-green-50 border-green-200 hover:bg-green-100 text-green-700"
    >
      {isCurrentProcessing ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <Mail className="h-4 w-4 mr-2" />
      )}
      Skicka inbjudan
    </Button>
  );
};
